import getCurrentMonth from "@mkt/utils/getCurrentMonth"
import isDynamicValue from "@mkt/utils/isDynamicValue"
import { Text } from "iq-blueberry"
import SbEditable from "@mkt/ui/components/common/SbEditable"
import Img from "@mkt/ui/components/common/Img"
import { render } from "storyblok-rich-text-react-renderer"
import { isMobile } from "@mkt/utils/getDevice"

import CTA from "../CTA"
import * as S from "./styles.js"
import assertAssetURL from "@mkt/utils/assertAssetUrl.js"

const Hero = ({ type = "home", content, title, isLoans }) => {
  const heroImgSrc = isMobile()
    ? content?.image_mobile?.filename
    : content?.image_desktop?.filename

  return (
    <SbEditable content={content}>
      <div css={S.hero}>
        <div css={S.heroContainer(type, isLoans)}>
          <div css={S.heroInfo(type, isLoans)}>
            {type === "home" && !isLoans && (
              <>
                {content?.title && (
                  <Text
                    as="h1"
                    variant="heading-two"
                    variantDesk="heading-one"
                    css={S.heroTitle(type)}
                  >
                    {render(content?.title)}
                  </Text>
                )}

                {content?.subtitle && (
                  <Text
                    as="h2"
                    weight="400"
                    variant="heading-six"
                    variantDesk="heading-five"
                    css={S.heroSubtitle}
                    style={{
                      fontFamily: "'Source Sans Pro', sans-serif",
                    }}
                  >
                    {render(content?.subtitle)}
                  </Text>
                )}
              </>
            )}

            {isLoans && (
              <>
                {content?.title && (
                  <Text
                    as="h1"
                    weight="700"
                    variant="heading-two"
                    variantDesk="heading-two"
                    css={S.heroTitle(type, isLoans)}
                  >
                    {render(content?.title)}
                  </Text>
                )}

                {content?.subtitle && (
                  <Text
                    as="span"
                    weight="400"
                    defaultColor="subtitle"
                    variant="heading-six"
                    variantDesk="heading-five"
                    css={S.heroSubtitle}
                  >
                    {render(content?.subtitle)}
                  </Text>
                )}
              </>
            )}

            {type === "list" && (
              <>
                {content?.subtitle && (
                  <Text
                    as="h2"
                    defaultColor="common"
                    variant="heading-five"
                    variantDesk="heading-five"
                    weight="400"
                    css={S.heroSubtitle}
                    style={{
                      fontFamily: "'Source Sans Pro', sans-serif",
                    }}
                  >
                    {content?.subtitle}
                  </Text>
                )}

                {content?.title && (
                  <Text
                    as="h1"
                    defaultColor="subtitle"
                    variant="heading-three"
                    variantDesk="heading-one"
                    css={S.heroTitle}
                  >
                    {isDynamicValue(content?.title, "[month]")
                      ? getCurrentMonth()
                      : render(title)}
                  </Text>
                )}
              </>
            )}

            {type === "home" && <CTA placeholder="Digite o seu CPF" />}
          </div>
          <figure css={S.heroImageContainer(type, isLoans)}>
            <Img
              css={S.heroImage}
              src={assertAssetURL(heroImgSrc)}
              alt={content?.image_desktop?.alt}
              loading="eager"
            />
          </figure>
        </div>
      </div>
    </SbEditable>
  )
}

export default Hero
